import React from 'react';

import { message } from 'antd';
import Image from 'next/legacy/image';

import { fetchOpenAirdrop } from '@api/airdrop';
import { Button } from '@element/index'
import I18n from '@utils/i18n';
import { CardDown } from '@widget/airdrop/countdown';

import { useMarketCoins } from '../hooks/useMarketCoins'
import { useUsdtValue } from '../hooks/useUsdtValue';
import { ModalProps, openModalIconClose } from './ModalIconClose';

import styles from './index.module.less';

export interface ContentProps {
  receiveId: string
  /** 结束时间 */
  endTime: number;
  /** 获得金额 */
  money: number;
  /** 币种 */
  coinCode: string;
  /** 祝福语 */
  greeting: string,
  /** 关闭弹窗 */
  closeModal: () => void;
  resolve: ModalProps['resolve'];
}

const Content: React.FC<ContentProps> = (props) => {
  const { endTime, money, closeModal, coinCode, receiveId, resolve, greeting } = props;

  const count = useUsdtValue({ coinCode, count: money });
  const { picturePath = '' } = useMarketCoins(coinCode);

  const handleOpenAirdrop = async () => {
    if (!receiveId) return
    const res = await fetchOpenAirdrop({ id: receiveId })
    if (!res.success) {
      message.error(I18n.t(res.msgKey))
      return;
    }
    closeModal();
    resolve({ status: true })
  }
  return (
    <div className={styles.lottieWrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{I18n.t('Z4DhP0gi')}</div>
        <div className={styles.desc}>{greeting}</div>
        <CardDown className={styles.countDown} endTime={endTime} id={'unActiveAirDrop'} />
      </div>
      <div className={styles.boxWrapper}>
        <div className={styles.boxImg}>
          <Image src={require('@images/airdrop/question.webp')} alt="kikitrade" />
        </div>
      </div>
      <div className={styles.unActiveBottom}>
        <div className={styles.coinCodeWrap}>
          {picturePath && <div className={styles.coinCodeImg}>
            <Image src={picturePath} alt="kikitrade" style={{ width: '100%', height: '100%' }}/>
          </div>}
          <p className={styles.activeTitle}>{money} {coinCode}</p>
        </div>
        <p className={styles.activeDesc}>{count}</p>
        <Button type='primary' className={styles.activeBtn} onClick={handleOpenAirdrop}>{I18n.t('Xaz8bANW')}</Button>
      </div>
    </div>
  );
}

export interface IOpenModalIconCloseParams extends Pick<ContentProps,
'money' | 'endTime' | 'coinCode' | 'receiveId' | 'greeting'> {
  el: HTMLElement;
}

export const openUnActiveModal = ({ el, ...rest }: IOpenModalIconCloseParams) => {
  return openModalIconClose({
    el,
    className: styles.topContainer,
    children: (params) => <Content {...rest} closeModal={params.removePreview} resolve={params.resolve} />
  })
}
